import React, {useContext} from 'react'
import {useTranslation} from '@lib/intl/useTranslations'
import {INavNotification} from '@api/user/account/notification/getNotification'
import NotificationItemLayout from '@feature/account/components/notifications/NotificationListItem/layout/NotificationItemLayout'
import useFormatNumber from '@hook/useFormatNumber'
import ic_default_user from '@image/ic_default_user.webp'
import useQueryFetchMe from '@hook/query/account/useQueryFetchMe'
import {NotificationPopoverContext} from '@component/header/GlobalNavigation/NotificationDropdown/NotificationDropdown'
import IconUnchanged from '@svg/notification/ic_unchanged.svg'
import useDark from '@hook/useDark'
import ic_default_user_dark from '@image/ic_default_user_dark.webp'

interface INotificationItem extends INavNotification {}

const PortfolioLossNotificationItem = (props: INotificationItem) => {
    const t = useTranslation()
    const {data} = props
    const {data: me} = useQueryFetchMe()
    const {isRenderDark} = useDark()
    const {displayBalance, displayPercent} = useFormatNumber()
    const {dailyReportOpen} = useContext(NotificationPopoverContext)

    if (
        Number(
            displayBalance(data?.earning, {
                showPreSign: false,
                isShowMinusSymbol: false,
            }),
        ) === 0
    ) {
        return (
            <>
                <NotificationItemLayout
                    {...props}
                    thumbnail={
                        me?.thumbnail ? me?.thumbnail : isRenderDark ? ic_default_user_dark.src : ic_default_user.src
                    }
                    renderIcon={<IconUnchanged className={'fill-gray01 dark:fill-dark_gray01'} />}
                    text={t(`globalNotification.NotificationItem.portfolio.same`, {
                        balance: `${displayBalance(data?.balance ?? 0, {showPreSign: true})}`,
                        earning: `${displayBalance(0, {showPreSign: true})}`,
                        score: `${displayPercent(0)}`,
                    })}
                    onClick={() => dailyReportOpen(data?.id)}
                />
            </>
        )
    }

    return (
        <>
            <NotificationItemLayout
                {...props}
                thumbnail={
                    me?.thumbnail ? me?.thumbnail : isRenderDark ? ic_default_user_dark.src : ic_default_user.src
                }
                text={t(`globalNotification.NotificationItem.portfolio.loss`, {
                    balance: `${displayBalance(data?.balance ?? 0, {showPreSign: true})}`,
                    earning: `${displayBalance(data?.earning ?? 0, {showPreSign: true})}`,
                    score: `${displayPercent(data?.score ?? 0)}`,
                })}
                onClick={() => dailyReportOpen(data?.id)}
            />
        </>
    )
}

export default PortfolioLossNotificationItem
